import Navigator from 'app';
export default Backbone.Model.extend({
  urlRoot: Navigator.config.api_base + 'watched_bills/',
  initialize: function initialize() {
    // turn category name into data category code
    if (this.get("category")) this.set("category", this.get("category").replace(/ /g, '_'));
    // this.set("status_date", new Date(this.get("status_date")));
  }
});